import AnimationTour from './AnimationTour';

export default AnimationTour;
